import './style.less';
import '../../../../assets/inspinia/plugins/metisMenu/jquery.metisMenu';

export default function($stateParams, $log) {
  'ngInject';

  const vm = this;
  vm.$onInit = activate;
  vm.stateParams = $stateParams;

  function activate() {
    $log.debug('Self Study Nav Loaded');
  }
}



// WEBPACK FOOTER //
// ./src/app/components/selfStudy/nav/controller.js